import { initializeApp } from "firebase/app";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const envObject = process.env;

const firebaseConfig = {
  apiKey: envObject.REACT_APP_FIREBASE_APIKEY,
  authDomain: envObject.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: envObject.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: envObject.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: envObject.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: envObject.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore();
export default app;
export const storage = getStorage(app);
export const provider = new GoogleAuthProvider();
